module.exports = __webpack_public_path__ + "img/report-landpage-blue.3dfdb5ea.svg";